import { AuUtilsFunctions } from '@app/shared';
import { addIncidentExternalData } from '../components/incident/state/incidents.actions';
import { addRequestExternalData } from '../components/request/state/requests.action';
import { addWorkOrderExternalData } from '../components/work-order/state/work-order.actions';
import { CmmsPages, ICmmsState } from '../state/cmms.reducer';
import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { addAssetExternalData } from '../components/assets/state/assets.actions';
import { addFileExternalData } from '../components/files/state/files.action';
import { openNewMessage } from '@app/pages/messages/state/messages.action';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CmmsSharedService {
	newFile: Subject<boolean> = new Subject<boolean>();
	constructor(private store$: Store<ICmmsState>) {}

	setExternalDataForNewComponent(page: CmmsPages, current) {
		const pageActions = {
			[CmmsPages.newWorkOrder]: {
				action: addWorkOrderExternalData,
			},
			[CmmsPages.newIncident]: {
				action: addIncidentExternalData,
			},
			[CmmsPages.newRequest]: {
				action: addRequestExternalData,
			},
			[CmmsPages.newAsset]: {
				action: addAssetExternalData,
			},
			[CmmsPages.files]: {
				action: addFileExternalData,
			},
			[CmmsPages.messages]: {
				action: openNewMessage,
			},
		};

		const addLocation = (id: string, name: string, type: string) => {
			locations.push({
				locationId: id,
				name: name,
				locationType: AuUtilsFunctions.capitalizeText(type),
			});
		};

		const locations = [];

		current?.locations?.forEach(location => {
			const { locationId, name, locationType } = location;
			addLocation(locationId, name, locationType);
		});

		if (current.location) {
			const { id, name, type } = current.location;
			addLocation(id, name, type);
		}

		let coordinates = null;

		if (current?.coordinates) {
			coordinates = {
				x: current?.coordinates?.x,
				y: current?.coordinates?.y,
				z: current?.coordinates?.z,
			};
		}

		const data = {
			locations: page === CmmsPages.newAsset ? [locations[0]] : locations,
			coordinates: coordinates,
		};

		if (CmmsPages.files === page) {
			const classifications = current?.classifications.map(
				classification => classification.pk
			);

			data['pk'] = current.file;
			data['classifications'] = classifications;
		}

		this.store$.dispatch(pageActions[page].action(data));
	}
}
